import { Form, Field, Cell, CellGroup, Icon, Picker } from "vant";
import { getToken } from "@/utils/auth.js";
import {
  sendCodeMsg,
  verifyMsg,
  resgister,
  getDKYzm,
  verifyDKYzm,
  getBankList
} from "@/api/register.js";
import { getUserByWxId } from "@/api/user.js";
import { getWXCode } from "@/utils/login.js";
import { plusXing } from "@/utils/formatter.js";
import $xy from "./xieyi.js";
export default {
  name: "Register",
  //import引入的组件需要注入到对象中才能使用
  components: {
    [Form.name]: Form,
    [Field.name]: Field,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Icon.name]: Icon,
    [Picker.name]: Picker
  },
  data() {
    return {
      content: $xy.content,
      showXieYi: false,
      bindRead: false,
      columns: [{ bankId: 11, bankName: "工商銀行s" }],
      showPicker: false,
      formSeen: false,
      submitDisabled: false,
      bindStep: false,
      checkIDCard: /(^\d{15}$)|(^\d{17}([0-9]|X)$)/,
      checkPhone: /^1[3456789]\d{9}$/,
      sendCodeText: "发送短信验证码",
      sendCodeDisabled: false,
      userInfo: {
        name: "",
        idCard: "",
        phoneNum: "",
        isBind: "0",
        fastPayRequestDTO: {
          bindId: "", //代扣验证码返回的ID
          verifyMsg: "" //代扣验证码
        },
        DKYHKH: "",
        DKKHH: "",
        DKKHHName: ""
      },
      lastState: {}, //发送验证码时的userInfo状态
      codeMsg: "",
      userShow: false,
      user: {},
      phone: ""
    };
  },
  created() {
    console.log("Register.vue created");
    this.getBankList();
  },
  mounted() {
    this.getWXCodeOrShowRegister();
  },
  computed: {},
  watch: {},
  methods: {
    getWXCodeOrShowRegister() {
      let openId = getToken();
      console.log(openId);
      if (
        openId == undefined ||
        openId == null ||
        openId === "" ||
        openId === "null"
      ) {
        // openId为空，调用微信接口获取CODE
        getWXCode(this.$route.path);
      } else {
        // openId不为空
        getUserByWxId(openId)
          .then(res => {
            if (res.data.code === 200) {
              const user = res.data.results;
              console.log("user");
              console.log(user);
              if (user == null) {
                // 未注册
                this.formSeen = true;
              } else {
                // 已注册
                this.$toast("您已注册");
                this.userShow = true;
                this.user = user;
                this.phone = `tel:${user.roleNum}`;
              }
            } else {
              this.$toast.fail("请求失败");
            }
          })
          .catch(err => {
            console.log(err);
          });
      }
    },
    onClickSendCode() {
      if (
        this.userInfo.phoneNum == null ||
        this.userInfo.phoneNum === "" ||
        this.userInfo.idCard == null ||
        this.userInfo.idCard === ""
      ) {
        this.$toast.fail("请填写完整个人信息！");
      } else if (this.checkPhone.test(this.userInfo.phoneNum)) {
        // 个人信息校验通过
        if (this.bindStep) {
          if (
            this.userInfo.DKYHKH == null ||
            this.userInfo.DKYHKH === "" ||
            this.userInfo.DKKHH == null ||
            this.userInfo.DKKHH === ""
          ) {
            this.$toast.fail("代扣信息不能为空！");
          } else {
            this.sendDKCode();
          }
        } else {
          this.sendCode();
        }
      } else {
        this.$toast.fail("请检查手机号格式！");
      }
    },
    startCountDown() {
      this.sendCodeText = "60s后重新获取";
      this.sendCodeDisabled = true;
      let t = 60;
      let timer = setInterval(() => {
        if (t <= 1) {
          clearInterval(timer);
          this.sendCodeText = this.bindStep ? "发送绑卡验证码" : "发送短信验证码";
          this.sendCodeDisabled = false;
        } else {
          t--;
          this.sendCodeText = t + "s后重新获取";
        }
      }, 1000);
    },
    //获取普通验证码
    sendCode() {
      this.lastState = Object.assign({}, this.userInfo);
      console.log("发送验证码");
      // 开启验证码倒计时
      this.startCountDown();
      //请求后台
      const data = {
        phoneNum: this.userInfo.phoneNum
      };
      sendCodeMsg(this.$qs.stringify(data))
        .then(res => {
          if (res.data.code === 200) {
            this.$toast.success(res.data.message);
          } else {
            this.$toast.fail("发送失败");
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    //校验验证码
    onSubmit() {
      console.log("onSubmit");
      if (this.lastState.isBind && this.userInfo.isBind != this.lastState.isBind) {
        this.$toast.fail("请重新发送验证码");
      } else if (!this.bindStep) {
        // 校验普通验证码
        const verifyMsgData = {
          phoneNum: this.userInfo.phoneNum,
          code: this.codeMsg
        };
        verifyMsg(this.$qs.stringify(verifyMsgData))
          .then(res => {
            console.log(res);
            if (res.data.code === 200) {
              // 校验成功
              this.register();
            } else {
              this.$toast.fail(res.data.message);
            }
          })
          .catch(err => {
            console.log(err);
          });
      } else {
        this.verifyDKCode();
      }
    },
    //获取代扣验证码
    sendDKCode() {
      console.log("get dkCode");
      if (this.bindRead != true) {
        this.$toast.fail("请先同意协议内容");
      } else if (
        this.userInfo.DKYHKH == null ||
        this.userInfo.DKYHKH === "" ||
        this.userInfo.DKKHH == null ||
        this.userInfo.DKKHH === ""
      ) {
        this.$toast.fail("代扣信息不能为空！");
      } else {
        this.lastState = Object.assign({}, this.userInfo);
        this.startCountDown();
        let query = {
          accountName: this.userInfo.name,
          accountNumber: this.userInfo.DKYHKH,
          bankId: this.userInfo.DKKHH,
          idCardNum: this.userInfo.idCard,
          phoneNum: this.userInfo.phoneNum
        };
        console.log("获取验证码", query);
        getDKYzm(query).then(res => {
          console.log("返回结果", res);
          if (res.data.code === 200) {
            this.userInfo.fastPayRequestDTO.bindId = parseInt(res.data.results);
            this.$toast.success("验证码发送成功");
          } else {
            console.log(res.data.results);
            this.$toast.fail(res.data.message);
          }
        });
      }
    },
    verifyDKCode() {
      if (!this.userInfo.fastPayRequestDTO.bindId) {
        this.$toast.fail("请先发送绑卡验证码");
        return;
      }
      this.submitDisabled = true;
      const query = {
        accountName: this.userInfo.name,
        accountNumber: this.userInfo.DKYHKH,
        bankId: this.userInfo.DKKHH,
        idCardNum: this.userInfo.idCard,
        phoneNum: this.userInfo.phoneNum,
        bindId: Number(this.userInfo.fastPayRequestDTO.bindId),
        verifyMsg: this.codeMsg
      };
      verifyDKYzm(query)
        .then(res => {
          if (res.data.code === 200) {
            this.$toast.success("绑卡成功");
            setTimeout(() => {
              location.reload();
            }, 1000);
          } else {
            this.$toast.fail(res.data.message);
            this.submitDisabled = false;
          }
        })
        .catch(err => {
          console.log(err);
          this.$toast.fail("绑卡失败，请重试");
          this.submitDisabled = false;
        });
    },
    register() {
      this.submitDisabled = true;
      const resgisterData = {
        name: this.userInfo.name,
        idCard: this.userInfo.idCard,
        phoneNum: this.userInfo.phoneNum,
        wxId: getToken(),
        bindId: null,
        isBind: "0",
        verifyMsg: this.codeMsg
      };
      resgister(resgisterData)
        .then(res => {
          console.log(res);
          if (res.data.code === 200) {
            if (this.userInfo.isBind == "1") {
              this.$toast.success("注册成功，请继续完成绑卡验证");
              this.bindStep = true;
              this.lastState = Object.assign({}, this.userInfo);
              this.codeMsg = "";
              this.sendCodeText = "发送绑卡验证码";
              this.sendCodeDisabled = false;
              this.submitDisabled = false;
            } else {
              this.$toast.success("注册成功");
              setTimeout(() => {
                location.reload();
              }, 1000);
            }
          } else {
            this.$toast.fail(res.data.message);
            this.submitDisabled = false;
          }
        })
        .catch(err => {
          console.log(err);
          this.$toast.fail("注册失败，请重试");
          this.submitDisabled = false;
        });
    },
    plusXing(str, frontLen, endLen) {
      return plusXing(str, frontLen, endLen);
    },

    //开户行选择确认
    onConfirm(value) {
      this.userInfo.DKKHHName = value.bankName;
      this.userInfo.DKKHH = value.bankId;
      this.showPicker = false;
    },
    //获取银行列表
    getBankList() {
      console.log("获取银行列表");
      getBankList().then(res => {
        console.log(res);
        if (res.data.code === 200) {
          this.columns = res.data.results.data;
        }
      });
    },
    readContent() {
      this.showXieYi = true;
    }
  },
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
